module.exports = __webpack_public_path__ + "static/33-HOW-TO-ATTRACT-GEN-Z-TO-THE-WORKPLACE-1c7c685c28da49cedd701d8435484aea.jpg";